"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Toggle switch component
 * @note You can pass in a cssClass prop of 'toggle-switch--yes-no' to display a toogle switch with 'Yes'and 'No' labels
 */
const ToggleSwitch = ({
  input,
  id,
  label,
  disabled,
  loading,
  inactive,
  meta,
  ...otherProps
}) => {
  id = !id ? (0, _uuid.v4)() : id;
  const checked = !loading && input && input.hasOwnProperty('value') ? input.value : false;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledToggleSwitch, {
    role: "group",
    "aria-label": label,
    loading: loading,
    ...otherProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ToggleSwitchWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Input, {
        className: "toggle-switch__checkbox",
        type: "checkbox",
        disabled: disabled,
        checked: checked,
        ...input,
        id: id
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Label, {
        className: "toggle-switch__switch-label",
        htmlFor: id,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InnerLabel, {
          className: "toggle-switch__switch-label__inner"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SwitchLabel, {
          className: "toggle-switch__switch-label__switch"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ScreenReaderLabel, {
          className: "sr-only",
          children: label
        })]
      })]
    })
  });
};

ToggleSwitch.propTypes = {
  label: _propTypes.default.string,
  selectedLabel: _propTypes.default.string,
  unSelectedLabel: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  contrast: _propTypes.default.bool,
  meta: _propTypes.default.object
};
ToggleSwitch.defaultProps = {
  selectedLabel: 'On',
  unSelectedLabel: 'Off',
  disabled: false,
  loading: false,
  contrast: false,
  meta: {}
};
var _default = ToggleSwitch;
exports.default = _default;